import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';
import { PagerService } from 'src/app/Services/pager.service';
import { DatePipe } from '@angular/common';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ProductionApprovalFilters, ProductionApprovalDetails, updateStatus } from 'src/app/Models/Admin/production-approval';
import { ProductionApprovalService } from 'src/app/Services/admin-rights/production-approval.service';
import { element } from 'protractor';
import { Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-artwork',
  templateUrl: './artwork.component.html',
  styleUrls: ['./artwork.component.css'],
  providers: [DatePipe]
})
export class ArtworkComponent implements OnInit {
  loader: string = '';
  artworkFilters: ProductionApprovalFilters = new ProductionApprovalFilters();
  artworkDetails: ProductionApprovalDetails[] = [];
  mainArtworkDetails: ProductionApprovalDetails[] = [];
  selectedJobNumber: any;
  selectedRMHName: any;
  selectedJobType: any;
  selected: any = 0;
  @ViewChild('file') input;
  selectedBrand: any;
  selectedCrop: any;
  selectedLanguage: any;
  selectedStatus: any;
  selectedMonth: any;
  files: File[] = [];
  fileName: string = '';
  selectedPaging: any;
  selectedState: any;
  sortDirection: string = '';
  ascNumberSort: boolean = true;
  dropdownList = [
    { item_id: '1', item_text: 'Jan' },
    { item_id: '2', item_text: 'Feb' },
    { item_id: '3', item_text: 'Mar' },
    { item_id: '4', item_text: 'Apr' },
    { item_id: '5', item_text: 'May' },
    { item_id: '6', item_text: 'Jun' },
    { item_id: '7', item_text: 'Jul' },
    { item_id: '8', item_text: 'Aug' },
    { item_id: '9', item_text: 'Sep' },
    { item_id: '10', item_text: 'Oct' },
    { item_id: '11', item_text: 'Nov' },
    { item_id: '12', item_text: 'Dec' }
  ];
  dropdownSettings1: IDropdownSettings = {
    singleSelection: false,
    idField: 'jobNumberID',
    textField: 'jobNumberName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings2: IDropdownSettings = {
    singleSelection: false,
    idField: 'rMHCode',
    textField: 'rMHName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings3: IDropdownSettings = {
    singleSelection: false,
    idField: 'jobTypeID',
    textField: 'jobTypeName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings4: IDropdownSettings = {
    singleSelection: false,
    idField: 'cropID',
    textField: 'cropName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings5: IDropdownSettings = {
    singleSelection: false,
    idField: 'brandID',
    textField: 'brandName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings6: IDropdownSettings = {
    singleSelection: false,
    idField: 'languageID',
    textField: 'languageName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings7: IDropdownSettings = {
    singleSelection: false,
    idField: 'stateID',
    textField: 'stateName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings8: IDropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings9: IDropdownSettings = {
    singleSelection: false,
    idField: 'requirementStatusID',
    textField: 'requirementStatusName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  constructor(private snackBar: MatSnackBarComponent, private _pagerService: PagerService, private datepipe: DatePipe,
    private router: Router, private productionApprovalService: ProductionApprovalService,private toastr: ToastrService) { }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.artworkProductionFilters();
    this.artworkProductionDetails();
  }

  artworkProductionFilters() {
    this.loader = 'block';
    this.productionApprovalService.artworkProductionFilters()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.artworkFilters = resData.data;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.msg);
          //this.snackBar.openSnackBar(resData.msg, 'Close', 'red-snackbar');
          this.loader = 'none';
        }
      }
      );
  }

  artworkProductionDetails() {
    this.loader = 'block';    
    this.selectedJobNumber = undefined;
    this.selectedRMHName = undefined;
    this.selectedJobType = undefined;
    this.selectedBrand = undefined;
    this.selectedCrop = undefined;
    this.selectedLanguage = undefined;
    this.selectedStatus = undefined;
    this.selectedMonth = undefined;
    this.selectedState = undefined;
    this.productionApprovalService.artworkProductionDetails(this.selectedJobNumber, this.selectedRMHName, this.selectedJobType, this.selectedBrand, this.selectedCrop,
      this.selectedLanguage, this.selectedStatus, this.selectedMonth, this.selectedState)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.artworkDetails = resdata.data;
          this.mainArtworkDetails = resdata.data
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          //this.snackBar.openSnackBar(resdata.msg, 'Close', 'red-snackbar');
          this.loader = 'none';
        }
      })
  }

  excelDownload() {
    this.loader = 'block';
    let selectJobNo: any[] = this.selectedJobNumber;
    let selectRmh: any[] = this.selectedRMHName;
    let selectJob: any[] = this.selectedJobType;
    let selectBrand: any[] = this.selectedBrand;
    let selectCrop: any[] = this.selectedCrop;
    let selectLanguage: any[] = this.selectedLanguage;
    let selectStatus: any[] = this.selectedStatus;
    let selectMonth: any[] = this.selectedMonth;
    let selectState: any[] = this.selectedState;
    let customJobNo: string = "";
    let customVendor: string = "";
    let customRmh: string = "";
    let customJob: string = "";
    let customBrand: string = "";
    let customCrop: string = "";
    let customLanguage: string = "";
    let customStatus: string = "";
    let customMonth: string = "";
    let customState: string = "";
    if (selectJobNo != undefined) {
      selectJobNo.forEach(x => {
        if (x.length == 0) {
          customJobNo = "";
        }
        else {
          if (customJobNo == "") {
            customJobNo = x.jobNumberName;
          }
          else {
            customJobNo = customJobNo.concat(",");
            customJobNo = customJobNo.concat(x.jobNumberName);
          }
        }
      })
    }
    if (selectRmh != undefined) {
      selectRmh.forEach(x => {
        if (x.length == 0) {
          customRmh = "";
        }
        else {
          if (customRmh == "") {
            customRmh = x.rMHCode;
          }
          else {
            customRmh = customRmh.concat(",");
            customRmh = customRmh.concat(x.rMHCode);
          }
        }
      })
    }
    if (selectJob != undefined) {
      selectJob.forEach(x => {
        if (x.length == 0) {
          customJob = "";
        }
        else {
          if (customJob == "") {
            customJob = x.jobTypeName;
          }
          else {
            customJob = customJob.concat(",");
            customJob = customJob.concat(x.jobTypeName);
          }
        }
      })
    }
    if (selectBrand != undefined) {
      selectBrand.forEach(x => {
        if (x.length == 0) {
          customBrand = "";
        }
        else {
          if (customBrand == "") {
            customBrand = x.brandName;
          }
          else {
            customBrand = customBrand.concat(",");
            customBrand = customBrand.concat(x.brandName);
          }
        }
      })
    }
    if (selectCrop != undefined) {
      selectCrop.forEach(x => {
        if (x.length == 0) {
          customCrop = "";
        }
        else {
          if (customCrop == "") {
            customCrop = x.cropName;
          }
          else {
            customCrop = customCrop.concat(",");
            customCrop = customCrop.concat(x.cropName);
          }
        }
      })
    }
    if (selectLanguage != undefined) {
      selectLanguage.forEach(x => {
        if (x.length == 0) {
          customLanguage = "";
        }
        else {
          if (customLanguage == "") {
            customLanguage = x.languageName;
          }
          else {
            customLanguage = customLanguage.concat(",");
            customLanguage = customLanguage.concat(x.languageName);
          }
        }
      })
    }
    if (selectStatus != undefined) {
      selectStatus.forEach(x => {
        if (x.length == 0) {
          customStatus = "";
        }
        else {
          if (customStatus == "") {
            customStatus = x.requirementStatusID.toString();
          }
          else {
            customStatus = customStatus.concat(",");
            customStatus = customStatus.concat(x.requirementStatusID.toString());
          }
        }
      })
    }
    if (selectMonth != undefined) {
      selectMonth.forEach(x => {
        if (x.length == 0) {
          customMonth = "";
        }
        else {
          if (customMonth == "") {
            customMonth = x.item_id;
          }
          else {
            customMonth = customMonth.concat(",");
            customMonth = customMonth.concat(x.item_id);
          }
        }
      })
    }
    if (selectState != undefined) {
      selectState.forEach(x => {
        if (x.length == 0) {
          customState = "";
        }
        else {
          if (customState == "") {
            customState = x.stateName;
          }
          else {
            customState = customState.concat(",");
            customState = customState.concat(x.stateName);
          }
        }
      })
    }
    this.productionApprovalService.downloadExcel(customJobNo, customRmh, customJob, customBrand, customCrop,
      customLanguage, customStatus, customMonth, customState, customVendor)
      .subscribe(
        success => {
          var date = new Date();
          let latest_date = this.datepipe.transform(date, 'dd-MMM-yy')
          let Name = localStorage.getItem('mcmt_userName').split(' ');
          let Firstname = Name[0];
          let LastName = Name[1];
          let ExcelName = Firstname + '_' + LastName + '_ProductionApproval_' + latest_date + '.xlsx';
          saveAs(success, ExcelName);

          this.loader = 'none';
        },
        err => {
          this.toastr.error("No record/s available");
          //this.snackBar.openSnackBar("No record/s available", 'Close', 'red-snackbar');
          this.loader = 'none';
        }
      );
  }

  updateStatus(): void {
    this.loader = 'block';
    let updateArtworkProduction: updateStatus[] = []
    let active: number = 0;
    this.mainArtworkDetails.forEach(element => {
      if (element.isActive == true) {        
        active = 1;
        var approvedRequirement = {
          JobNumber: element.jobNumber
        }
        updateArtworkProduction.push(approvedRequirement)
      }
    })
    if(active == 1){
    this.productionApprovalService.updateArtworkProduction(updateArtworkProduction)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          if (resdata.data[0].status == 'true') {
            this.toastr.success(resdata.data[0].msg);
            //this.snackBar.openSnackBar(resdata.data[0].msg, 'Close', 'green-snackbar');
            this.loader = 'none';
            this.selected = 0;
            this.artworkProductionDetails();
          } else {
            this.toastr.error(resdata.data[0].msg);
            //this.snackBar.openSnackBar(resdata.data[0].msg, 'Close', 'red-snackbar');
            this.loader = 'none';
          }
        }
        else {
          this.toastr.error(resdata.msg);
          //this.snackBar.openSnackBar(resdata.msg, 'Close', 'red-snackbar');
          this.loader = 'none';
        }
      })
    }    
    else {
      this.toastr.error('Requirement not selected');
      //this.snackBar.openSnackBar('Requirement not selected', 'Close', 'red-snackbar');
      this.loader = 'none';
    }
  }

  filesAdd(files: File[]) {
    this.files = [];
    this.files = files;
    let fileNameParts: string[] = files[0].name.split('.');
    let fileType = files[0].name.split('.')[fileNameParts.length - 1];
    if (fileType != 'xls' && fileType != 'xlsx') {
      this.toastr.error('Please Select Valid File Type.');
      //this.snackBar.openSnackBar('Please Select Valid File Type.', 'Close', 'red-snackbar');
      this.loader = 'none';
      this.input.nativeElement.value = null;
      return false;
    }
    this.loader = 'block';
    this.productionApprovalService.uploadArtworkProduction(<File>this.files[0])
      .subscribe((resData: any) => {
        if (resData.status == true) {
          if (resData.data[0].status == 'true') {
            //this.toastr.success(resData.data[0].msg);
            this.toastr.success('Uploaded Successfully');
            //this.snackBar.openSnackBar(resData.data[0].msg, 'Close', 'green-snackbar');
            this.artworkProductionDetails();
            this.input.nativeElement.value = null;
            this.loader = 'none';
          } else {
            this.toastr.error(resData.data[0].msg);
            //this.snackBar.openSnackBar(resData.data[0].msg, 'Close', 'red-snackbar');
            this.loader = 'none';
            this.input.nativeElement.value = null;
          }
        }
        else {
          this.toastr.error('Some problem occurred, please try again later.');
          //this.snackBar.openSnackBar('Some problem occurred, please try again later.', 'Close', 'red-snackbar');
          this.loader = 'none';
          this.input.nativeElement.value = null;
        }
        this.files = [];
        this.loader = 'none';
      });
    this.files = files;
    this.fileName = files[0].name;
  }

  filter() {
    let customRmh: any[] = this.selectedRMHName;
    let customBrand: any[] = this.selectedBrand;
    let customJob: any[] = this.selectedJobType;
    let customCrop: any[] = this.selectedCrop;
    let customLanguage: any[] = this.selectedLanguage;
    let customJobNo: any[] = this.selectedJobNumber;
    let customState: any[] = this.selectedState;
    let customMonth: any[] = this.selectedMonth;
    let customStatus: any[] = this.selectedStatus;
    let filteredRmh = [];
    let filteredBrand = [];
    let filteredCrop = [];
    let filteredJob = [];
    let filteredLanguage = [];
    let filteredWH = [];
    let filteredState = [];
    let filteredMonth = [];
    let filteredStatus = [];
    let ArtworkDetail: ProductionApprovalDetails[] = this.mainArtworkDetails;
    let resultDetail: ProductionApprovalDetails[] = [];
    let resultId = [];
    let splitString: any[] = [];
    let filter: boolean = false;
    if (customRmh != undefined && customRmh.length > 0) {
      customRmh.forEach(element => {
        ArtworkDetail.forEach(detail => {
          if (detail.rmhId == element.rMHCode) {
            filteredRmh.push(detail.jobNumber);
          }
        })
      });
      resultId = filteredRmh;
      filter = true;
    }
    if (customBrand != undefined && customBrand.length > 0) {
      customBrand.forEach(element => {
        ArtworkDetail.forEach(detail => {
          if (detail.brand == element.brandName) {
            filteredBrand.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredBrand.includes(x))
        }
      }
      else {
        resultId = filteredBrand;
      }
      filter = true;
    }
    if (customCrop != undefined && customCrop.length > 0) {
      customCrop.forEach(element => {
        ArtworkDetail.forEach(detail => {
          if (detail.crop == element.cropName) {
            filteredCrop.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredCrop.includes(x))
        }
      }
      else {
        resultId = filteredCrop;
      }
      filter = true;
    }
    if (customJob != undefined && customJob.length > 0) {
      customJob.forEach(element => {
        ArtworkDetail.forEach(detail => {
          if (detail.jobType == element.jobTypeName) {
            filteredJob.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredJob.includes(x))
        }
      }
      else {
        resultId = filteredJob;
      }
      filter = true;
    }
    if (customLanguage != undefined && customLanguage.length > 0) {
      customLanguage.forEach(element => {
        ArtworkDetail.forEach(detail => {
          if (detail.language == element.languageName) {
            filteredLanguage.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredLanguage.includes(x))
        }
      }
      else {
        resultId = filteredLanguage;
      }
      filter = true;
    }
    if (customJobNo != undefined && customJobNo.length > 0) {
      customJobNo.forEach(element => {
        ArtworkDetail.forEach(detail => {
          if (detail.jobNumber == element.jobNumberName) {
            filteredWH.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredWH.includes(x))
        }
      }
      else {
        resultId = filteredWH;
      }
      filter = true;
    }
    if (customStatus != undefined && customStatus.length > 0) {
      customStatus.forEach(element => {
        ArtworkDetail.forEach(detail => {
          if (detail.status == element.requirementStatusName) {
            filteredStatus.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredStatus.includes(x))
        }
      }
      else {
        resultId = filteredStatus;
      }
      filter = true;
    }
    if (customState != undefined && customState.length > 0) {
      customState.forEach(element => {
        ArtworkDetail.forEach(detail => {
          if (detail.state == element.stateName) {
            filteredState.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredState.includes(x))
        }
      }
      else {
        resultId = filteredState;
      }
      filter = true;
    }
    if (customMonth != undefined && customMonth.length > 0) {
      customMonth.forEach(element => {
        ArtworkDetail.forEach(detail => {
          splitString = detail.requirementMonth.split("'");
          if (splitString[0] == element.item_text) {
            filteredMonth.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredMonth.includes(x))
        }
      }
      else {
        resultId = filteredMonth;
      }
      filter = true;
    }
    if (filter == true) {
      resultId.forEach(element => {
        ArtworkDetail.forEach(detail => {
          if (detail.jobNumber == element) {
            resultDetail.push(detail);
          }
        })
      })
      this.artworkDetails = resultDetail;
    }
    else {
      this.artworkDetails = this.mainArtworkDetails;
    }
    this.sortDirection = '';
  }
  onItemSelect() {

  }
  onSelectAll() {

  }

  onItemSelectJob() {
    let jobNo = this.selectedJobNumber;
    let customBrand = [];
    let customRmh = [];
    let customCrop = [];
    let customJob = [];
    let customLanguage = [];
    let customMonth = [];
    let customState = [];
    let customJobNo = [];
    let customStatus = [];
    this.artworkFilters.jobNumbers.forEach(x => {
      jobNo.forEach(element => {
        if (element.jobNumberName == x.jobNumberName) {
          customJobNo.push(x);
        }
      });
    })
    let active: boolean = true;
    this.artworkFilters.brands.forEach(x => {
      customJobNo.forEach(element => {
        if (x.brandID == element.brandID.trim()) {
          if (customBrand.length == 0) {
            customBrand.push(x);
          }
          else {
            customBrand.forEach(y => {
              if (y.brandID == x.brandID) {
                active = false;
              }
            })
            if (active == true) {
              customBrand.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.artworkFilters.status.forEach(x => {
      customJobNo.forEach(element => {
        if (x.requirementStatusID == element.statusID) {
          if (customStatus.length == 0) {
            customStatus.push(x);
          }
          else {
            customStatus.forEach(y => {
              if (y.item_id == x.requirementStatusID) {
                active = false;
              }
            })
            if (active == true) {
              customStatus.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.artworkFilters.states.forEach(x => {
      customJobNo.forEach(element => {
        if (x.stateName == element.stateName) {
          if (customState.length == 0) {
            customState.push(x);
          }
          else {
            customState.forEach(y => {
              if (y.stateName == x.stateName) {
                active = false;
              }
            })
            if (active == true) {
              customState.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.artworkFilters.crops.forEach(x => {
      customJobNo.forEach(element => {
        if (x.cropID == element.cropID) {
          if (customCrop.length == 0) {
            customCrop.push(x);
          }
          else {
            customCrop.forEach(y => {
              if (y.cropID == x.cropID) {
                active = false;
              }
            })
            if (active == true) {
              customCrop.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.artworkFilters.jobTypes.forEach(x => {
      customJobNo.forEach(element => {
        if (x.jobTypeID == element.jobTypeID) {
          if (customJob.length == 0) {
            customJob.push(x);
          }
          else {
            customJob.forEach(y => {
              if (y.jobTypeID == x.jobTypeID) {
                active = false;
              }
            })
            if (active == true) {
              customJob.push(x);
            }
            active = true
          }
        }
      });
    })
    this.artworkFilters.languages.forEach(x => {
      customJobNo.forEach(element => {
        if (x.languageID == element.languageID) {
          if (customLanguage.length == 0) {
            customLanguage.push(x);
          }
          else {
            customLanguage.forEach(y => {
              if (y.languageID == x.languageID) {
                active = false;
              }
            })
            if (active == true) {
              customLanguage.push(x);
            }
            active = true
          }
        }
      });
    })
    this.artworkFilters.rmhs.forEach(x => {
      customJobNo.forEach(element => {
        if (x.rMHCode == element.rMHCode) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.rMHCode == x.rMHCode) {
                active = false;
              }
            })
            if (active == true) {
              customRmh.push(x);
            }
            active = true
          }
        }
      });
    })
    this.dropdownList.forEach(x => {
      customJobNo.forEach(element => {
        if (x.item_id == element.month) {
          if (customMonth.length == 0) {
            customMonth.push(x);
          }
          else {
            customMonth.forEach(y => {
              if (y.item_id == x.item_id) {
                active = false;
              }
            })
            if (active == true) {
              customMonth.push(x);
            }
            active = true
          }
        }
      });
    })
    this.selectedJobType = customJob;
    this.selectedLanguage = customLanguage;
    this.selectedMonth = customMonth;
    this.selectedRMHName = customRmh;
    this.selectedState = customState;
    this.selectedCrop = customCrop;
    this.selectedBrand = customBrand;
    this.selectedStatus = customStatus;
  }

  onItemSelectState() {
    let customState: any[] = this.selectedState;
    let customRmh = [];
    let finalRMH = [];
    let customLanguage = [];
    let finalLanguage = [];
    let active: boolean = true;
    this.artworkFilters.maMapping.forEach(x => {
      customState.forEach(detail => {
        if (x.stateName == detail.stateName) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.stateName == x.stateName) {
                active = false;
              }
            })
            if (active == true) {
              customRmh.push(x);
            }
            active = true
          }
        }
      })
    })
    this.artworkFilters.rmhs.forEach(x => {
      customRmh.forEach(detail => {
        if (x.rMHCode == detail.rMHCode) {
          if (finalRMH.length == 0) {
            finalRMH.push(x);
          }
          else {
            finalRMH.forEach(y => {
              if (y.rMHCode == x.rMHCode) {
                active = false;
              }
            })
            if (active == true) {
              finalRMH.push(x);
            }
            active = true
          }
        }
      })
    })
    this.artworkFilters.mapping.forEach(x => {
      customState.forEach(detail => {
        if (x.state == detail.stateName) {
          if (customLanguage.length == 0) {
            customLanguage.push(x);
          }
          else {
            customLanguage.forEach(y => {
              if (y.state == x.state) {
                active = false;
              }
            })
            if (active == true) {
              customLanguage.push(x);
            }
            active = true
          }
        }
      })
    })
    this.artworkFilters.languages.forEach(x => {
      customLanguage.forEach(detail => {
        if (x.languageName == detail.languageName) {
          if (finalLanguage.length == 0) {
            finalLanguage.push(x);
          }
          else {
            finalLanguage.forEach(y => {
              if (y.languageName == x.languageName) {
                active = false;
              }
            })
            if (active == true) {
              finalLanguage.push(x);
            }
            active = true
          }
        }
      })
    })
    this.selectedRMHName = finalRMH;
    this.selectedLanguage = finalLanguage;
  }

  onStateDeSelect() {
    this.onItemSelectState()
  }

  onJobDeSelect() {
    this.onItemSelectJob()
  }

  onItemSelectAllJob() {
    let customBrand = [];
    let customRmh = [];
    let customCrop = [];
    let customJob = [];
    let customLanguage = [];
    let customMonth = [];
    let customStatus = [];
    let customState = [];
    let customJobNo = [];
    this.artworkFilters.jobNumbers.forEach(x => {
      customJobNo.push(x);
    })
    let active: boolean = true;
    this.artworkFilters.brands.forEach(x => {
      customJobNo.forEach(element => {
        if (x.brandID == element.brandID) {
          if (customBrand.length == 0) {
            customBrand.push(x);
          }
          else {
            customBrand.forEach(y => {
              if (y.brandID == x.brandID) {
                active = false;
              }
            })
            if (active == true) {
              customBrand.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.artworkFilters.status.forEach(x => {
      customJobNo.forEach(element => {
        if (x.requirementStatusID == element.statusID) {
          if (customStatus.length == 0) {
            customStatus.push(x);
          }
          else {
            customStatus.forEach(y => {
              if (y.item_id == x.requirementStatusID) {
                active = false;
              }
            })
            if (active == true) {
              customStatus.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.artworkFilters.states.forEach(x => {
      customJobNo.forEach(element => {
        if (x.stateName == element.stateName) {
          if (customState.length == 0) {
            customState.push(x);
          }
          else {
            customState.forEach(y => {
              if (y.stateName == x.stateName) {
                active = false;
              }
            })
            if (active == true) {
              customState.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.artworkFilters.crops.forEach(x => {
      customJobNo.forEach(element => {
        if (x.cropID == element.cropID) {
          if (customCrop.length == 0) {
            customCrop.push(x);
          }
          else {
            customCrop.forEach(y => {
              if (y.cropID == x.cropID) {
                active = false;
              }
            })
            if (active == true) {
              customCrop.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.artworkFilters.jobTypes.forEach(x => {
      customJobNo.forEach(element => {
        if (x.jobTypeID == element.jobTypeID) {
          if (customJob.length == 0) {
            customJob.push(x);
          }
          else {
            customJob.forEach(y => {
              if (y.jobTypeID == x.jobTypeID) {
                active = false;
              }
            })
            if (active == true) {
              customJob.push(x);
            }
            active = true
          }
        }
      });
    })
    this.artworkFilters.languages.forEach(x => {
      customJobNo.forEach(element => {
        if (x.languageID == element.languageID) {
          if (customLanguage.length == 0) {
            customLanguage.push(x);
          }
          else {
            customLanguage.forEach(y => {
              if (y.languageID == x.languageID) {
                active = false;
              }
            })
            if (active == true) {
              customLanguage.push(x);
            }
            active = true
          }
        }
      });
    })
    this.artworkFilters.rmhs.forEach(x => {
      customJobNo.forEach(element => {
        if (x.rMHCode == element.rMHCode) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.rMHCode == x.rMHCode) {
                active = false;
              }
            })
            if (active == true) {
              customRmh.push(x);
            }
            active = true
          }
        }
      });
    })
    this.dropdownList.forEach(x => {
      customJobNo.forEach(element => {
        if (x.item_id == element.month) {
          if (customMonth.length == 0) {
            customMonth.push(x);
          }
          else {
            customMonth.forEach(y => {
              if (y.item_id == x.item_id) {
                active = false;
              }
            })
            if (active == true) {
              customMonth.push(x);
            }
            active = true
          }
        }
      });
    })
    this.selectedJobType = customJob;
    this.selectedLanguage = customLanguage;
    this.selectedMonth = customMonth;
    this.selectedRMHName = customRmh;
    this.selectedState = customState;
    this.selectedCrop = customCrop;
    this.selectedBrand = customBrand;
    this.selectedStatus = customStatus;
  }
  onJobAllDeSelect() {
    this.selectedJobType = [];
    this.selectedLanguage = [];
    this.selectedMonth = [];
    this.selectedRMHName = [];
    this.selectedState = [];
    this.selectedCrop = [];
    this.selectedBrand = [];
  }
  onItemSelectAllState() {
    let customRmh = [];
    let finalRMH = [];
    let customLanguage = [];
    let finalLanguage = [];
    let customState = [];
    this.artworkFilters.states.forEach(x => {
      customState.push(x);
    })
    let active: boolean = true;
    this.artworkFilters.maMapping.forEach(x => {
      customState.forEach(detail => {
        if (x.stateName == detail.stateName) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.stateName == x.stateName) {
                active = false;
              }
            })
            if (active == true) {
              customRmh.push(x);
            }
            active = true
          }
        }
      })
    })
    this.artworkFilters.rmhs.forEach(x => {
      customRmh.forEach(detail => {
        if (x.rMHCode == detail.rMHCode) {
          if (finalRMH.length == 0) {
            finalRMH.push(x);
          }
          else {
            finalRMH.forEach(y => {
              if (y.rMHCode == x.rMHCode) {
                active = false;
              }
            })
            if (active == true) {
              finalRMH.push(x);
            }
            active = true
          }
        }
      })
    })
    this.artworkFilters.mapping.forEach(x => {
      customState.forEach(detail => {
        if (x.state == detail.stateName) {
          if (customLanguage.length == 0) {
            customLanguage.push(x);
          }
          else {
            customLanguage.forEach(y => {
              if (y.state == x.state) {
                active = false;
              }
            })
            if (active == true) {
              customLanguage.push(x);
            }
            active = true
          }
        }
      })
    })
    this.artworkFilters.languages.forEach(x => {
      customLanguage.forEach(detail => {
        if (x.languageName == detail.languageName) {
          if (finalLanguage.length == 0) {
            finalLanguage.push(x);
          }
          else {
            finalLanguage.forEach(y => {
              if (y.languageName == x.languageName) {
                active = false;
              }
            })
            if (active == true) {
              finalLanguage.push(x);
            }
            active = true
          }
        }
      })
    })
    this.selectedRMHName = finalRMH;
    this.selectedLanguage = finalLanguage;
  }
  onStateAllDeSelect() {
    this.selectedRMHName = [];
    this.selectedLanguage = [];
  }

  sort() {
    let sortedArray: ProductionApprovalDetails[] = [];
    let splitString: any[] = [];
    if (this.ascNumberSort == true) {
      this.dropdownList.forEach(x => {
        this.artworkDetails.forEach(element => {
          splitString = element.requirementMonth.split("'");
          if (x.item_text == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = false;
      this.sortDirection = 'asc';
      this.artworkDetails = sortedArray;
    }
    else {
      this.dropdownList.forEach(x => {
        this.artworkDetails.forEach(element => {
          splitString = element.requirementMonth.split("'");
          if (x.item_text == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = true;
      this.sortDirection = 'desc';
      this.artworkDetails = sortedArray.reverse();
    }
  }

  selectAll() {
    if (this.selected == 0) {
      this.artworkDetails.forEach(function (detail) {
        if (detail.status == "Artwork Awaited") {
          detail.isActive = true;
        }
      })
    }
    if (this.selected == 1) {
      this.artworkDetails.forEach(function (detail) {
        if (detail.status == "Artwork Awaited") {
          detail.isActive = false;
        }
      })
    }
  }

  check(index: any) {
    if (this.artworkDetails[index].status == "Artwork Awaited") {
      return 'false'
    }
    else {
      return 'true'
    }
  }

  updateIsactive(index: any) {
   
    let selectedIdCustom = this.artworkDetails[index].jobNumber;
    let isActiveCustom = this.artworkDetails[index].isActive;
    let requirementTypeCustom = this.artworkDetails[index].requirementType;
    this.mainArtworkDetails.forEach(function (detail) {
      if (detail.jobNumber == selectedIdCustom && detail.requirementType == requirementTypeCustom) {
        detail.isActive = isActiveCustom;
      }
    })
  }

  ConvertToCurrency(value:any)
  {
    var parts = value.toString().replace(',','').split(".");
    if(parts[0].length > 3){
      parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
    }
    return parts.join(".");
  }
}
